module.exports = __webpack_public_path__ + "static/hit_1-58bda2898ea388f12b01c4d6fb9aba9a.png";